/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Retailer } from './Retailer';

export type ProductExclusion = {
    id: string;
    type: ProductExclusion.type;
    value: string;
    retailers: Array<Retailer>;
    isActive: boolean;
};

export namespace ProductExclusion {

    export enum type {
        SKU = 'SKU',
        NAME = 'NAME',
        AI = 'AI',
    }


}

